import { DrillContext } from "../../components/dashdrill/types";

const STORAGE_KEY = "sonabhy.drill.session";

export interface StoredDrillSession {
  page: "dashboard" | "analytics" | "service";
  targetKey: string;
  context?: DrillContext;
  stamp: number;
}

export class DrillSession {
  static set(session: StoredDrillSession) {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(session));
  }

  static get(): StoredDrillSession | null {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    try {
      return JSON.parse(raw) as StoredDrillSession;
    } catch {
      return null;
    }
  }

  static clear() {
    sessionStorage.removeItem(STORAGE_KEY);
  }
}
